import { createPageMetaData } from './createPageMetaData';

export type { MetaData, Props } from './createPageMetaData';
export default createPageMetaData('Mobiworkx');
